import { createSlice } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

import { RecipePaginator } from '../../types/fam-graphql'
import type { RootState } from '../store'
import {
  getServiceState,
  getServiceReducers,
  ServiceValues,
} from '../../helpers/ReduxHelpers'

import { actionTypes } from './types'
import { Input } from './types/state'

export const name = 'switchcourse'

export type SwitchCourseState = {
  input: Input | null
  recipes: RecipePaginator | null
  sides: RecipePaginator | null
  replaceRecipeInPlan: ServiceValues
  recipeMaincomponent: any
}

//
// Initial state
//

const initialState: SwitchCourseState = {
  input: null,
  recipes: null,
  sides: null,
  replaceRecipeInPlan: getServiceState(),
  recipeMaincomponent: null,
}

const replaceRecipeInPlanReducer = getServiceReducers('replaceRecipeInPlan')
const replaceMainComponentReducer = getServiceReducers('replaceMainComponent')

//
// Slice (Actions & Reducers)
//

const slice = createSlice({
  name,
  initialState,
  reducers: {
    init: () => undefined,
    setInput: (state, action: actionTypes.setInput) => {
      state.input = action.payload
    },
    setRecipes: (state, action: actionTypes.setRecipes) => {
      state.recipes = action.payload
    },
    setSides: (state, action: actionTypes.setRecipes) => {
      state.sides = action.payload
    },
    loadRecipes: (_state, _action: actionTypes.loadRecipes) => void null,
    loadSides: (_state, _action: actionTypes.loadRecipes) => void null,
    //
    replaceRecipeInPlanRequest: replaceRecipeInPlanReducer.request,
    replaceRecipeInPlanSuccess: replaceRecipeInPlanReducer.success,
    replaceRecipeInPlanError: replaceRecipeInPlanReducer.error,
    replaceRecipeInPlanReset: replaceRecipeInPlanReducer.reset,
    //
    replaceMainComponentRequest: replaceMainComponentReducer.request,
    replaceMainComponentSuccess: replaceMainComponentReducer.success,
    replaceMainComponentError: replaceMainComponentReducer.error,
    replaceMainComponentReset: replaceMainComponentReducer.reset,
  },
  extraReducers: {
    [HYDRATE]: (_state, action) => {
      return action.payload[name]
    },
  },
})

export const { reducer, actions } = slice

//
// Selectors
//

const root = (state: RootState) => state[name]
const input = (state: RootState) => root(state).input
const recipes = (state: RootState) => root(state).recipes
const sides = (state: RootState) => root(state).sides

export const selectors = {
  input,
  recipes,
  sides,
}
